export {
  isIdentifierName,
  isIdentifierChar,
  isIdentifierStart,
} from "./identifier";
export {
  isReservedWord,
  isStrictBindOnlyReservedWord,
  isStrictBindReservedWord,
  isStrictReservedWord,
  isKeyword,
} from "./keyword";
